<template>
    <div>
      <header>
        <span>活动结束</span>
      </header>
      <div class="main">
        <h1>
          抱歉，您查看的活动已结束。<br/>
        </h1>
        
      </div>
      <footerNumber type="1"/>
    </div>
  </template>
  
  <script>
  import footerNumber from "@/components/footer/footerNumber";
  export default {
    name: "activeClose",
    components: {footerNumber},
  }
 

  </script>
  
  <style lang="scss" scoped>
  header {
    height: 108px;
    width: 100%;
    background: #0091C5;
    span {
      font-size: 30px;
      color: #FFFFFF;
      line-height: 108px;
      font-weight: bold;
    }
  }
  .main {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 20px;
    margin-top: 20px;
    h1 {
      font-weight: 400;
      font-size: 28px;
      color: #333333;
      text-align: left;
    }
  }
  </style>
  